<div class="h-100">
    @if (type === 'widget') {
		<div class="flex-align-center flex-space-between pad-bottom-M pad-M"
			 [class.c-p]="!_loading && !_initializing && applications.length > 0"
			 (click)="openDrawer()">
			<span class="font-MM fw-700">{{ 'global.leastPerformantApps'|translate }}</span>
			<img *ngIf="!_loading && !_initializing && applications.length > 0" src="assets/icons/arrow-right.svg"
				 height="12" alt="">
		</div>
    }
	<app-table-component
		[loading]="_initializing || _loading"
		[columnDefinitions]="columnDefinitions"
		[data]="filteredApplications"
		[height]="'calc(100% - 45.59px)'"
		[type]="type"
		(sorted)="onSorted($event)"
		(rowClick)="onRowClick($event)">
		<!-- Custom templates -->
		<ng-template #applicationTemplate let-row>
			<app-display-application [application]="row.application"></app-display-application>
		</ng-template>
		<ng-template #usageTemplate let-row>
			<div class="w-100 flex-center">
				<app-chips-count [value]="row.userCount" type="user" bold></app-chips-count>
			</div>
		</ng-template>
		<ng-template #lcpTemplate let-row>
			<div class="flex-center">
				<div class="impact-bubble" [ngClass]="{ 'little-impact': row.lcp && row.lcp < 2500, 'medium-impact': row.lcp && row.lcp < 4000 && row.lcp >= 2500, 'great-impact': row.lcp && row.lcp >= 4000, 'no-impact' : !row.lcp}">
					<span class="font-M fw-700 text-center">{{getFcpLcp(row.lcp)}}</span>
				</div>
			</div>
		</ng-template>
		<ng-template #fcpTemplate let-row>
			<div class="flex-align-center flex-justify-end">
				<div class="impact-bubble" [ngClass]="{ 'little-impact': row.fcp && row.fcp < 1800, 'medium-impact': row.fcp && row.fcp < 3000 && row.fcp >= 1800, 'great-impact': row.fcp && row.fcp >= 3000, 'no-impact' : !row.fcp }">
					<span class="font-M fw-700 text-center">{{getFcpLcp(row.fcp)}}</span>
				</div>
			</div>
		</ng-template>
	</app-table-component>
</div>
